import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { wizardMessages } from "../messages";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { InitialStateType, CreationResult } from "../types";
import { getJobs } from "../api";

type DomainsAndPartitionsProps = {
  state: InitialStateType;
  dispatch: (data: any) => void;
  setLoadingText: (text: undefined | string) => void;
};

type EventCollectionJob = {
  "@odata.type": string;
  name: string;
  disabled: boolean;
};

const DomainsAndPartitions = ({ state, setLoadingText }: DomainsAndPartitionsProps) => {
  const [jobs, setJobs] = useState<Array<EventCollectionJob>>([]);
  const intl = useIntl();
  const { failed, managed }: CreationResult = state.creationResult;

  useEffect(() => {
    if (managed.length) {
      setLoadingText("Loading");
      getJobs(managed)
        .then((res) => {
          setJobs(res as Array<EventCollectionJob>);
        })
        .catch(() => {
          setJobs([]);
        })
        .finally(() => {
          setLoadingText(undefined);
        });
    }
  }, [managed]);

  return (
    <Wrapper>
      {failed?.length > 0 && (
        <MessageBar
          messageBarType={MessageBarType.error}
          truncated={true}
          isMultiline={false}
          styles={{
            root: {
              maxWidth: "700px",
            },
          }}
        >
          {intl.formatMessage(wizardMessages.creationError)}{" "}
          <a
            href="https://support.cayosoft.com/hc/en-us/articles/36184031651725"
            target="_blank"
            rel="noreferrer"
          >
            {intl.formatMessage(wizardMessages.creationErrorLink)}
          </a>
          <div>
            {failed?.map((f, index: number) => (
              <p key={index}>
                <b>{f.name}</b> Error: {f.message}
              </p>
            ))}
          </div>
        </MessageBar>
      )}
      <BodyWrapper>
        {managed.length > 0 && (
          <>
            <p>
              <b>{intl.formatMessage(wizardMessages.creationManaged)}</b>
            </p>
            {managed?.map((m, index: number) => (
              <ManagedItem key={index}>{m}</ManagedItem>
            ))}
          </>
        )}

        {jobs.length > 0 && (
          <>
            <p>
              <b>{intl.formatMessage(wizardMessages.jobsTitle)}</b>
            </p>
            {jobs?.map((job, index: number) => (
              <Jobs key={index}>
                <p>
                  {job.name} - {`(Status: ${job.disabled ? "Disabled" : "Running"})`}
                </p>
              </Jobs>
            ))}
          </>
        )}
      </BodyWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const BodyWrapper = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ManagedItem = styled.p`
  margin: 0;
`;

const Jobs = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  p {
    margin: 0;
  }
`;

export default DomainsAndPartitions;
